
const mutations = {
  setJobs: (state, payload) => {
    state.jobs = payload
  },
  setJobsCategory: (state, payload) => {
    state.jobsCategory = payload
  },
  setJobListCity: (state, payload) => {
    state.listJobCity = payload
  },
  setJobListNeighborhood: (state, payload) => {
    state.listJobNeighborhood = payload
  },
  setJobProfileVideo: (state, payload) => {
    state.jobProfileVideo = payload
  },
  setJobsAlert: (state, payload) => {
    state.jobsAlert = payload
  },
  setTotalJobsAlert: (state, payload) => {
    state.totalJobsAlert = payload
  },
  setJobsPending: (state, payload) => {
    state.listJobsPending = payload
  },
  setJobAlertSettings: (state, payload) => {
    state.jobAlertSettings = payload
  },
  setListInterestedTalents: (state, payload) => {
    state.listInterestedTalents = payload
  },
  setTotalInterestedTalent: (state, payload) => {
    state.totalInterestedTalent = payload
  },
  setListJoinedTalents: (state, payload) => {
    state.listJoinedTalents = payload
  },
  setTotalJoinedTalent: (state, payload) => {
    state.totalJoinedTalent = payload
  },
  setListWaitForConfirmationTalents: (state, payload) => {
    state.listWaitForConfirmationTalents = payload
  },
  setTotalWaitForConfirmationTalent: (state, payload) => {
    state.totalWaitForConfirmationTalent = payload
  },
  setListOtherTopRatedTalents: (state, payload) => {
    state.listOtherTopRatedTalents = payload
  },
  setTotalOtherTopRatedTalent: (state, payload) => {
    state.totalOtherTopRatedTalent = payload
  },
  setTotalJob: (state, payload) => {
    state.totalJob = payload
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/jobs/mutations.js